<template>
  <div>
    <div class="welcome" style="border: 0px solid red;">
      <row
        style="border:0px solid green;position: inherit;display:contents;width:100%;"
      >
        <div class="box box-primary">
          <div class="box-header with-border">
            <lte-button
              style="float:right"
              type="btn
                              btn-primary"
              right_icon="fa fa-plus"
              @click="addNew($event)"
              >{{ $t("property.addnew") }}</lte-button
            >
            <lte-button
              style="float:right"
              type="btn
                              btn-primary"
              right_icon="glyphicon glyphicon-save"
              @click="onImportExcel($event)"
              >{{ $t("common.importFileExcel") }}</lte-button
            >
          </div>
          <div class="box-body">
            <div>
              <b-table
                :items="gridDataList"
                :fields="gridColumns"
                class="mt-3"
                outlined
                responsive
              >
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template #cell(actions)="row">
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn btn-danger dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <i class="fa fa-fw fa-ellipsis-h"></i>
                    </button>
                    <ul class="dropdown-menu" style="min-width: 50px">
                      <li>
                        <button
                          class="btn btn-primary btn-sm"
                          style="margin-left: 6px;"
                          @click="onOpenEditInput(row.item)"
                        >
                          <i class="glyphicon glyphicon-edit"></i>
                        </button>
                      </li>
                      <li style="margin-top: 5px">
                        <button
                          class="btn btn-danger btn-sm"
                          style="margin-left: 6px;"
                          @click="onOpenDelete(row.item)"
                        >
                          <i class="glyphicon glyphicon-trash"></i>
                        </button>
                      </li>
                    </ul>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
          <div
            v-if="gridDataList.length > 0"
            class="box-footer clearfix"
            style="display:contents;"
          >
            <paginator
              style="padding: 0 15px"
              :totalItem="paginateData.totalItem"
              :currentPage="paginateData.currentPage"
              :pageSize="paginateData.pageSize"
              :totalPage="paginateData.totalPage"
              @onpaginate="onPagination"
            />
          </div>
        </div>
      </row>
    </div>
    <!--  -->
    <supplier-detail-modal
      ref="supplierDetailModal"
      @callbackSupplierList="callbackSupplierList"
    />
    <!--  -->
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <import-supplier-modal 
      ref="importSupplierModal" 
      @callbackSupplierList="callbackSupplierList"/>
  </div>
</template>
<script>
import LTEButton from "@/components/LTEButton.vue";
import Paginator from "@/components/CustomPaginator.vue";
import SupplierDetailModal from "./SupplierDetailModal";
import Loading from "vue-loading-overlay";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import LTEModal from "@/components/LTEModal.vue";
import ImportSupplierModal from "./ImportSupplierModal"
//
import { mapActions, mapGetters } from "vuex";
import utils from "@/lib/utils";
export default {
  components: {
    "lte-core-alert": LTECoreAlert,
    paginator: Paginator,
    "lte-button": LTEButton,
    loading: Loading,
    SupplierDetailModal,
    "lte-modal": LTEModal,
    ImportSupplierModal
  },
  data: () => ({
    gridColumns: [
      {
        label: "common.nonumber",
        key: "nonumber",
        class: "text-center "
      },
      {
        label: "supplierManagement.supplierCode",
        key: "supplierCode",
        class: "text-center "
      },
      {
        label: "supplierManagement.supplierName",
        key: "supplierName",
        class: "text-center "
      },
      {
        label: "supplierManagement.supplierAddress",
        key: "supplierAddress",
        class: "text-center "
      },
      {
        label: "supplierManagement.supplierEmail",
        key: "supplierEmail",
        class: "text-center "
      },
      {
        label: "supplierManagement.supplierPhone",
        key: "supplierPhone",
        class: "text-center "
      },
      {
        label: "supplierManagement.supplierNote",
        key: "supplierNote",
        class: "text-center "
      },
      { key: "actions", label: "common.action" }
    ],
    gridDataList: [],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    isLoading: false,
    originalRecordData: [],
    isModalVisible: false,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    supplierSearch: {
      searchText: null
    },
  }),
  watch: {
    GET_ASSET_SUPPLIER_LIST_DATA: function() {
      let paginate = this.GET_ASSET_SUPPLIER_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.gridDataList = [];
      let data = this.GET_ASSET_SUPPLIER_LIST_DATA.results;
      data.forEach((element, i) => {
        let id = element.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let item = {
          id: id,
          nonumber: nonumber,
          supplierCode: element.code,
          supplierName: element.name,
          supplierAddress: element.address,
          supplierEmail: element.email,
          supplierPhone: element.phone,
          supplierNote: element.note
        };
        this.gridDataList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_ACCOUNT_DATA",
      "GET_ASSET_SUPPLIER_LIST_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    showError: function(msg) {
      this.ON_SHOW_TOAST({
        message: this.$t(msg),
        styleType: "danger"
      });
    },
    addNew: function(event) {
      event.preventDefault();
      this.$refs.supplierDetailModal.onAddNewSupplier();
    },
    onOpenEditInput: function(data) {
      this.$refs.supplierDetailModal.onUpdateSupplier(data);
    },
    onOpenDelete: function(row) {
      this.originalRecordData = row;
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    onPagination: function(data) {
      this.getAssetSupplierList(data);
    },
    refreshData: function(data) {
      this.supplierSearch.searchText = data.searchText
      this.getAssetSupplierList(1);
    },
    getAssetSupplierList: function(page) {
      let filter = {
        params: {
          page: page,
          searchText: this.supplierSearch.searchText
        }
      };
      this.isLoading = true;
      this.GET_ASSET_SUPPLIER_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    callbackSupplierList: function() {
      this.getAssetSupplierList(this.paginateData.currentPage);
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_ASSET_SUPPLIER(this.originalRecordData)
        .then(
          function() {
            this.callbackSupplierList();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    onImportExcel: function() {
      this.$refs.importSupplierModal.onShowImport()
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_ASSET_SUPPLIER_LIST",
      "DELETE_ASSET_SUPPLIER"
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Property/SupplierManagement.vue